"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeechHistoryItemResponse = void 0;
const core = __importStar(require("../../core"));
const SpeechHistoryItemResponseModelVoiceCategory_1 = require("./SpeechHistoryItemResponseModelVoiceCategory");
const FeedbackItem_1 = require("./FeedbackItem");
const SpeechHistoryItemResponseModelSource_1 = require("./SpeechHistoryItemResponseModelSource");
const HistoryAlignmentsResponseModel_1 = require("./HistoryAlignmentsResponseModel");
const DialogueInputResponseModel_1 = require("./DialogueInputResponseModel");
exports.SpeechHistoryItemResponse = core.serialization.object({
    historyItemId: core.serialization.property("history_item_id", core.serialization.string()),
    requestId: core.serialization.property("request_id", core.serialization.string().optional()),
    voiceId: core.serialization.property("voice_id", core.serialization.string().optional()),
    modelId: core.serialization.property("model_id", core.serialization.string().optional()),
    voiceName: core.serialization.property("voice_name", core.serialization.string().optional()),
    voiceCategory: core.serialization.property("voice_category", SpeechHistoryItemResponseModelVoiceCategory_1.SpeechHistoryItemResponseModelVoiceCategory.optional()),
    text: core.serialization.string().optional(),
    dateUnix: core.serialization.property("date_unix", core.serialization.number()),
    characterCountChangeFrom: core.serialization.property("character_count_change_from", core.serialization.number()),
    characterCountChangeTo: core.serialization.property("character_count_change_to", core.serialization.number()),
    contentType: core.serialization.property("content_type", core.serialization.string()),
    state: core.serialization.unknown(),
    settings: core.serialization.record(core.serialization.string(), core.serialization.unknown()).optional(),
    feedback: FeedbackItem_1.FeedbackItem.optional(),
    shareLinkId: core.serialization.property("share_link_id", core.serialization.string().optional()),
    source: SpeechHistoryItemResponseModelSource_1.SpeechHistoryItemResponseModelSource.optional(),
    alignments: HistoryAlignmentsResponseModel_1.HistoryAlignmentsResponseModel.optional(),
    dialogue: core.serialization.list(DialogueInputResponseModel_1.DialogueInputResponseModel).optional(),
});
